import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import classes from './Press.css';
import BSMLogo from '../../assets/logos/benito-santos-mexico.svg';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import PressKit from '../../components/PressKit/PressKit';
import SectionMenu from '../../components/SectionMenu/SectionMenu';
import * as menuActions from '../../actions/MenuActions';
import { Helmet } from 'react-helmet';

const pressKits = [
    {
        title: 'Periódico El Informador',
        description:
            'Sección B, domingo 17 de mayo del 2015, sección Tapatío Cultural. Núm. 35132.',
        image: 'http://placehold.it/600x800',
        downloadLink: '#'
    },
    {
        title: 'Colección Flor de Teresa 2018',
        description: 'Benito Santos presenta su colección Flor de Teresa 2018.',
        image: 'http://placehold.it/600x800',
        collectionLink: '#',
        campaignLink: '#',
        downloadLink: '#'
    },
    {
        title: 'Colección Primavera Verano 2017',
        description:
            'Benito Santos presenta su colección Primavera Verano 2017.',
        image: 'http://placehold.it/600x800',
        collectionLink: '#',
        campaignLink: '#',
        downloadLink: '#'
    },
    {
        title: 'Revista Marie Claire',
        description: 'Año 26, núm. 03, pág. 47 y 118. Marzo del 2015.',
        image: 'http://placehold.it/600x800',
        downloadLink: '#'
    },
    {
        title: 'Colección Otoño Invierno 2017',
        description: 'Benito Santos presenta su colección Otoño Invierno 2017.',
        image: 'http://placehold.it/600x800',
        collectionLink: '#',
        campaignLink: '#',
        downloadLink: '#'
    },
    {
        title: 'Revista Cosmopolitan',
        description: 'Revista Cosmopolitan, 43/13. Julio 2015. Pág. 124.',
        image: 'http://placehold.it/600x800',
        downloadLink: '#'
    }
];

const menu = [
    {
        label: 'México',
        link: '/prensa'
    },
    {
        label: 'Novias',
        link: '/prensa/novias'
    }
];

class Press extends Component {
    componentDidMount() {
        this.props.hideAllMenus().then(() => {
            this.props.showTopMenu();
            this.props.showLeftMenu();
        });
    }

    render() {
        return (
            <Layout>
                <Helmet>
                    <title>Benito Santos - Prensa</title>
                </Helmet>
                <section className="container">
                    <header className="row justify-content-center">
                        <div className="col-sm-7 col-xl-4">
                            <SectionHeader
                                logo={BSMLogo}
                                logoAlt="Benito Santos - México"
                                title="Prensa"
                                subtitle="Medios"
                            >
                                <SectionMenu menuItems={menu} />
                            </SectionHeader>
                        </div>
                    </header>
                    <main>
                        <ul className={'row ' + classes.PressKitsList}>
                            {pressKits.map((pressKit, index) => (
                                <li className="col-md-6 col-lg-4" key={index}>
                                    <PressKit
                                        image={pressKit.image}
                                        title={pressKit.title}
                                        description={pressKit.description}
                                        collectionLink={pressKit.collectionLink}
                                        campaignLink={pressKit.campaignLink}
                                        downloadLink={pressKit.downloadLink}
                                    />
                                </li>
                            ))}
                        </ul>
                    </main>
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu
    };
};

const mapDispatchToStore = dispatch => {
    return bindActionCreators(
        {
            ...menuActions
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToStore)(Press);



// WEBPACK FOOTER //
// ./src/containers/Press/Press.js